import { useContext, useState, useRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from 'components';
import { filterStatusesParser } from 'helpers';
import { FlightStatusContext } from 'context';
import { useOnClickOutside } from 'hooks';
import {
  Container,
  TitleWrapper,
  Title,
  Value,
  List,
  IconWrapper,
  Item,
} from './Filter.style';

const Filter = () => {
  const { t, i18n } = useTranslation();
  const { translation: english } = i18n.getDataByLanguage('en');
  const [expand, setExpand] = useState(false);
  const {
    state: { flightsFilter, flights },
    dispatch,
  } = useContext(FlightStatusContext);
  const selectRef = useRef();
  useOnClickOutside(selectRef, () => setExpand(false));

  const availableStatuses = useMemo(
    () =>
      flights?.flightStatuses && filterStatusesParser(flights.flightStatuses),
    [flights]
  );

  const options = useMemo(() => {
    if (availableStatuses) {
      const array = availableStatuses
        .map((status) => {
          const obj = Object.entries(english).find(
            ([key, value]) =>
              key.includes('filter') &&
              value?.toLowerCase() === status?.toLowerCase()
          );
          return obj?.length > 0 && obj[0];
        })
        .filter((el) => el);

      return ['flightsstatus.results.status.any', ...array];
    }
  }, [availableStatuses, english]);

  const handleExpand = () => setExpand((prev) => !prev);

  const handleChange = (item) => {
    dispatch({
      type: 'HANDLE_CHANGE_STATE',
      payload: { flightsFilter: item },
    });
    setExpand(false);
  };

  return (
    <Container ref={selectRef}>
      <TitleWrapper onClick={handleExpand}>
        <Title>{`${t('flightstatus.results.filter')}:`}</Title>
        <Value>{t(flightsFilter)}</Value>
        <IconWrapper
          aria-label="icon-button"
          edge="end"
          expand={expand.toString()}
        >
          <Icon name="arrow" color="#000099" />
        </IconWrapper>
      </TitleWrapper>
      {expand && (
        <List>
          {options?.map((el) => (
            <Item key={el} onClick={() => handleChange(el)}>
              {t(el)}
            </Item>
          ))}
        </List>
      )}
    </Container>
  );
};

export default Filter;
